export default __webpack_public_path__ + "static/media/RadioButtonSelected.07902ffb.svg";